export default __webpack_public_path__ + "static/media/trade_returns.4ef3a96e.png";